export default "__VITE_ASSET__DE11a1WH__"